import React, { MouseEventHandler, VoidFunctionComponent } from "react";

interface Props {
  setIsZoom: (zoomStatus: boolean) => void;
  handleMouseMove: MouseEventHandler;
  medias: string[];
  zoomImages: string[];
  isMobileOrTablet: boolean,
  activeSlide: number;
  mousePosition: {
    x: number;
    y: number;
  };
}

export const ImageSliderZoom: VoidFunctionComponent<Props> = ({
  handleMouseMove,
  setIsZoom,
  medias,
  zoomImages,
  isMobileOrTablet,
  activeSlide,
  mousePosition
}) => {
  // Get the zoomed image URL for a given image index.
  const getImageZoom = (index: number) => {
    const url = medias[index];
    const regexUrlId = /\d\w*/;
    const matchedId = url.match(regexUrlId)?.[0];
    return matchedId ? zoomImages.find((zoomImage) => zoomImage.match(matchedId)) : "";
  }

  return (
    <div className="zoom-container">
      <div
        className="zoom-content"
        onMouseMove={handleMouseMove}
        onClick={() => {
          setIsZoom(false);
        }}
      >
        <img
          src={getImageZoom(activeSlide)}
          alt="Image agrandi"
          className="modal-image"
          style={
            !isMobileOrTablet
              ? {
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: `translate(-50%, -50%) scale(2)`,
                transformOrigin: `${mousePosition.x}px ${mousePosition.y}px`,
              }
              : {}
          }
        />
      </div>
    </div>
  )
}